import Papa from 'papaparse';
export const parseCsv = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const csv = e.target.result;
            Papa.parse(csv, {
                header: true,
                skipEmptyLines: true,
                complete: (result) => {
                    resolve({headers:result.meta.fields, data: result.data});
                },
                error: (error) => {
                    reject(error);
                }
            });
        };
        reader.readAsText(file);
    });
};